module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_5.0c3d5952.png";